import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import FrontPage from "./pages/FrontPage";
import Resources from "./pages/Resources";
import VeteranResources from "./pages/VeteranResources";
import Articles from "./pages/Articles";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminDashboard from "./pages/AdminDashboard";
import ArticleView from "./components/ArticleView";
import Nav from "./components/Nav";
import SEO from "./components/SEO";

const NotFound = () => (
  <div className="min-h-screen bg-gray-900 text-white font-serif">
    <SEO
      title="Page Not Found"
      description="The page you are looking for does not exist."
      noindex={true}
    />
    <Nav />
    <div className="max-w-4xl mx-auto px-4 py-16 text-center">
      <h1 className="text-5xl font-bold text-cyan-400 mb-4">404</h1>
      <p className="text-2xl text-white mb-2">Page Not Found</p>
      <p className="text-gray-400 mb-8">
        The page you are looking for does not exist or has been moved.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/"
          className="bg-cyan-500 text-gray-900 px-8 py-3 font-semibold hover:bg-cyan-400 transition-colors"
        >
          GO HOME
        </Link>
        <Link
          to="/resources"
          className="border border-cyan-500 text-cyan-400 px-8 py-3 font-semibold hover:bg-cyan-500 hover:text-gray-900 transition-colors"
        >
          VIEW RESOURCES
        </Link>
        <Link
          to="/articles"
          className="border border-cyan-500 text-cyan-400 px-8 py-3 font-semibold hover:bg-cyan-500 hover:text-gray-900 transition-colors"
        >
          READ ARTICLES
        </Link>
      </div>
      <p className="text-gray-500 mt-12 text-sm">
        Crisis? Call 988 | NH Rapid Response: 833-710-6477 | 2-1-1 NH
      </p>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main front page route */}
          <Route path="/" element={<FrontPage />} />

          {/* Other pages */}
          <Route path="/resources" element={<Resources />} />
          <Route
            path="/resources/category/:categorySlug"
            element={<Resources />}
          />
          <Route path="/resources/county/:countySlug" element={<Resources />} />
          <Route
            path="/resources/category/:categorySlug/county/:countySlug"
            element={<Resources />}
          />
          <Route path="/veterans" element={<VeteranResources />} />
          <Route path="/articles" element={<Articles />} />
          <Route
            path="/articles/category/:categorySlug"
            element={<Articles />}
          />
          <Route path="/articles/:id" element={<ArticleView />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Admin route */}
          <Route path="/admin" element={<AdminDashboard />} />

          {/* 404 Not Found route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
